import CancellableHelper from "@/requests/CancellableHelper";
import { ServiceTypeGroups } from "@/models/api/administration/servicesAndAttributes/ServiceTypeGroup";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { ServiceTypeGroupItems } from "@/models/api/administration/servicesAndAttributes/ServiceTypeGroupItems";
import { NewServiceTypeGroup } from "@/models/api/administration/servicesAndAttributes/NewServiceTypeGroup";
import { EditServiceTypeGroup } from "@/models/api/administration/servicesAndAttributes/EditServiceTypeGroup";

//#region Routes
export const URL_GET_SERVICE_TYPE_GROUPS = "/ServiceType/Group";
export const URL_GET_SERVICE_GROUP_ITEMS_PAGED = "/ServiceType/Group/${ServiceTypeGroupId}/Items/Paged";
export const URL_POST_ADD_SERVICE_GROUP = "/ServiceType/Group/Add";
export const URL_POST_EDIT_SERVICE_GROUP = "/ServiceType/Group/Edit";
export const URL_POST_ASSIGN_SERVICE_TYPE_TO_SERVICE_TYPE_GROUP =
  "/ServiceType/${ServiceTypeId}/Group/${ServiceTypeGroupId}/Assign";
export const URL_POST_UNASSIGN_SERVICE_TYPE_TO_SERVICE_TYPE_GROUP =
  "/ServiceType/${ServiceTypeId}/Group/${ServiceTypeGroupId}/Unassign";
export const URL_POST_REMOVE_SERVICE_GROUP = "/ServiceType/Group/${ServiceTypeGroupId}/Remove";
export const URL_GET_CHECK_IF_ANY_SERVICE_TYPE_PIN_TO_SERVICE_GROUP =
  "/ServiceType/Group/${ServiceTypeGroupId}/CheckIfAny";
export const URL_POST_ASSIGN_FILTERED_SERVICE_TYPE_TO_SERVICE_TYPE_GROUP =
  "/ServiceType/Group/${ServiceTypeGroupId}/Assign/Filtered";
export const URL_POST_UNASSIGN_ALL_SERVICE_TYPE_SERVICE_TYPE_GROUP =
  "/ServiceType/Group/${ServiceTypeGroupId}/Unassign/All";
//#endregion

const _getServiceTypeGroups = new CancellableHelper<ServiceTypeGroups>(URL_GET_SERVICE_TYPE_GROUPS, ServiceTypeGroups);
_getServiceTypeGroups.jsonSerializer = true;
export const getServiceTypeGroups = async (genericTableRequest: GenericTableRequest): Promise<ServiceTypeGroups> => {
  return await _getServiceTypeGroups.get({ ...genericTableRequest });
};

const _getServiceTypeForGroupFilter = new CancellableHelper<ServiceTypeGroupItems>(
  URL_GET_SERVICE_GROUP_ITEMS_PAGED,
  ServiceTypeGroupItems
);
_getServiceTypeForGroupFilter.jsonSerializer = true;
export const getServiceForGroup = async (
  genericTableRequest: GenericTableRequest,
  serviceTypeGroupId: number
): Promise<ServiceTypeGroupItems> => {
  return await _getServiceTypeForGroupFilter.get({
    ServiceTypeGroupId: serviceTypeGroupId,
    ...genericTableRequest,
  });
};

const _addServiceGroup = new CancellableHelper<number>(URL_POST_ADD_SERVICE_GROUP, "number");
export const addServiceGroup = async (model: NewServiceTypeGroup): Promise<number> => {
  return await _addServiceGroup.post(null, model);
};

const _editServiceGroup = new CancellableHelper<void>(URL_POST_EDIT_SERVICE_GROUP, null, true);
export const editServiceGroup = async (model: EditServiceTypeGroup): Promise<void> => {
  return await _editServiceGroup.post(null, model);
};

const _removeServiceTypeGroup = new CancellableHelper<null>(URL_POST_REMOVE_SERVICE_GROUP, null, true);
export const removeServiceTypeGroup = async (serviceTypeGroupId: number): Promise<null> => {
  return await _removeServiceTypeGroup.post({ ServiceTypeGroupId: serviceTypeGroupId }, null);
};

const _isAnyServiceInServiceGroup = new CancellableHelper<boolean>(
  URL_GET_CHECK_IF_ANY_SERVICE_TYPE_PIN_TO_SERVICE_GROUP,
  "boolean"
);
export const isAnyServiceInServiceGroup = async (serviceTypeGroupId: number): Promise<boolean> => {
  return await _isAnyServiceInServiceGroup.get({
    ServiceTypeGroupId: serviceTypeGroupId,
  });
};

const _assignServiceTypeToServiceTypeGroup = new CancellableHelper<null>(
  URL_POST_ASSIGN_SERVICE_TYPE_TO_SERVICE_TYPE_GROUP,
  null,
  true
);
export const assignServiceTypeToServiceTypeGroup = async (
  serviceTypeGroupId: number,
  serviceTypeId: number
): Promise<null> => {
  return await _assignServiceTypeToServiceTypeGroup.post(
    { ServiceTypeId: serviceTypeId, ServiceTypeGroupId: serviceTypeGroupId },
    null
  );
};

const _unassignServiceTypeFromServiceTypeGroup = new CancellableHelper<null>(
  URL_POST_UNASSIGN_SERVICE_TYPE_TO_SERVICE_TYPE_GROUP,
  null,
  true
);
export const unassignServiceTypeFromServiceTypeGroup = async (
  serviceTypeGroupId: number,
  serviceTypeId: number
): Promise<null> => {
  return await _unassignServiceTypeFromServiceTypeGroup.post(
    { ServiceTypeGroupId: serviceTypeGroupId, ServiceTypeId: serviceTypeId },
    null
  );
};

const _assignFilteredServiceTypeToServiceTypeGroup = new CancellableHelper<null>(
  URL_POST_ASSIGN_FILTERED_SERVICE_TYPE_TO_SERVICE_TYPE_GROUP,
  null,
  true
);
_assignFilteredServiceTypeToServiceTypeGroup.jsonSerializer = true;
export const assignFilteredServiceTypeToServiceTypeGroup = async (
  serviceTypeGroupId: number,
  genericTableRequest: GenericTableRequest
): Promise<null> => {
  return await _assignFilteredServiceTypeToServiceTypeGroup.post(
    { ServiceTypeGroupId: serviceTypeGroupId, ...genericTableRequest },
    null
  );
};

const _unassignAllServiceTypeFromServiceTypeGroup = new CancellableHelper<null>(
  URL_POST_UNASSIGN_ALL_SERVICE_TYPE_SERVICE_TYPE_GROUP,
  null,
  true
);
export const unassignAllServiceTypeFromServiceTypeGroup = async (serviceTypeGroupId: number): Promise<null> => {
  return await _unassignAllServiceTypeFromServiceTypeGroup.post({ ServiceTypeGroupId: serviceTypeGroupId }, null);
};
